import React from "react"
import Seo from "../../components/seo"
import Layout from "../../components/layout"
import { Link, graphql, navigate } from 'gatsby'
import NoteSideMenu from "../../components/note/note-side-menu"
import ArticleArea from "../../components/note/article-area"
import { colorCode } from "../../functions/middle-category-style"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import "../../styles/pc/page/note/filtered_articles.scss"
import "../../styles/sp/page/note/filtered_articles.scss"

export default function TagPost({ data, pageContext }) {
  const { noteTagName } = pageContext

  const handleCardClick = (url, e) => {

    e.stopPropagation();

    // クリックされた要素が a タグでない場合、記事カードのリンク先に遷移
    if (e.target.tagName.toLowerCase() !== 'a') {
      navigate(url);
    }
  };

  return (
    <Layout isNote={true}>
    <Seo
      type="article"
      title="ジェイフィールのオウンドメディア タグで絞り込み"
      description=""
      bobyClassName="menu26"
    />
    <div className="wrapper tag_area">
      {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
      <div className="catch_note">
        <div className="catch_note_in">
          {/*<p class="subtitle"><span></span></p>*/}
          <h2 className="maintitle"><span>#{ noteTagName }</span></h2>
        </div>{/* catch_in*/}
      </div>{/* /catch1 */}
      {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="path fixed pc_only">
          <div className="left_navi"><span className="vertical"><Link to="/">Home</Link>　/　<Link to="/note">J.Feel Note</Link>　/　<Link to={`/note/tag/` + noteTagName }  className="current">#{ noteTagName }</Link></span></div>
          </div>{/* left_navi */}
          <div className="main">
      {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
      <div className="contents contents_wrap">
        <div className="contents_in">
          <div className="padding_sp">{/* スマホのみ隙間 */}
            <div className="flex_wrap note_box note contents_in_l">

            {data.noteFilterByTag.edges.map(({ node }) => (

              <div key={node.notesId} className="flex_contents" onClick={(e) => handleCardClick(`/note/${node.notesId}`, e)}>

                <div className="contents_box sp_scroll_x">
                  <LazyAndPreloadImage imgUrl={node.thumbnail ? node.thumbnail.url : ''} alt={"記事サムネイル"} />
                </div>

                <div className="caption_box">
                  { node.middle_category ?
                    
                    <div className="article_category" style={{background: colorCode(node.middle_category.display_color ? node.middle_category.display_color[0] : '')}}>
                      <Link to={'/note/category/' + node.middle_category.name}>{node.middle_category.name}</Link>
                    </div>
                    
                    : ''
                  }

                  <Link to={'/note/' + node.notesId}>
                    <div className="article_title">{node.title}</div>
                  </Link>

                  <ul className="tag_list">
                    {node.tags.map((tag) => (
                      tag.type[0] === "ノートタグ" ?
                        <li key={tag.id}><Link to={'/note/tag/' + tag.name}>#{tag.name}</Link></li>
                      : ''
                    ))}
                  </ul>
                </div>

              </div>


              ))}

            </div>
            <NoteSideMenu />
          </div>{/* padding_sp スマホのみ隙間 */}
        </div>{/* contents_in */}
      </div>{/* /contents */}

    <ArticleArea />

      {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
      {/*//////////////////////////////* ↓コンテンツ02 * //////////////////////////////*/}

      {/* <NoteLists /> */}

      {/*//////////////////////////////* ↑コンテンツ02 * //////////////////////////////*/}
      </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">J.Feel Note - </span><span className="txt">ジェイフィールのオウンドメディア</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
  </Layout>
  )
}

export const query = graphql`
query TagQuery($id: String!) {
  noteFilterByTag: allMicrocmsNotes(
    sort: {fields: [publishedAt], order: DESC}
    filter: {tags: {elemMatch: {id: {eq: $id}}}}
  ) {
    edges {
      node {
        notesId
        title
        large_category
        middle_category {
          id
          name
          display_color
        }
        thumbnail {
          url
        }
        tags {
          id
          name
          type
        }
      }
    }
  }
}`
